export const GET_PROFILE_ACTION_TYPE = 'GET_PROFILE_ACTION_TYPE'
export const GET_PROFILE_SUCCEEDED_ACTION_TYPE = 'GET_PROFILE_SUCCEEDED_ACTION_TYPE'
export const GET_PROFILE_FAILED_ACTION_TYPE = 'GET_PROFILE_FAILED_ACTION_TYPE'

export const EXPORT_USER_GDPR_REPORT_ACTION_TYPE = 'EXPORT_USER_GDPR_REPORT_ACTION_TYPE'
export const EXPORT_USER_GDPR_REPORT_SUCCEEDED_ACTION_TYPE = 'EXPORT_USER_GDPR_REPORT_SUCCEEDED_ACTION_TYPE'
export const EXPORT_USER_GDPR_REPORT_FAILED_ACTION_TYPE = 'EXPORT_USER_GDPR_REPORT_FAILED_ACTION_TYPE'

export const GET_USER_CAN_EXPORT_GDPR_REPORT_ACTION_TYPE = 'GET_USER_CAN_EXPORT_GDPR_REPORT_ACTION_TYPE'
export const GET_USER_CAN_EXPORT_GDPR_REPORT_SUCCEEDED_ACTION_TYPE = 'GET_USER_CAN_EXPORT_GDPR_REPORT_SUCCEEDED_ACTION_TYPE'
export const GET_USER_CAN_EXPORT_GDPR_REPORT_FAILED_ACTION_TYPE = 'GET_USER_CAN_EXPORT_GDPR_REPORT_FAILED_ACTION_TYPE'
export const SET_USER_CAN_EXPORT_GDPR_REPORT_ACTION_TYPE = 'SET_USER_CAN_EXPORT_GDPR_REPORT_ACTION_TYPE'

export const REQUEST_USER_YEAR_IN_REVIEW_REPORT_ACTION_TYPE = 'REQUEST_USER_YEAR_IN_REVIEW_REPORT_ACTION_TYPE'
export const REQUEST_USER_YEAR_IN_REVIEW_REPORT_SUCCEEDED_ACTION_TYPE = 'REQUEST_USER_YEAR_IN_REVIEW_REPORT_SUCCEEDED_ACTION_TYPE'
export const REQUEST_USER_YEAR_IN_REVIEW_REPORT_FAILED_ACTION_TYPE = 'REQUEST_USER_YEAR_IN_REVIEW_REPORT_FAILED_ACTION_TYPE'

export const GET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_ACTION_TYPE = 'GET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_ACTION_TYPE'
export const GET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_SUCCEEDED_ACTION_TYPE = 'GET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_SUCCEEDED_ACTION_TYPE'
export const GET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_FAILED_ACTION_TYPE = 'GET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_FAILED_ACTION_TYPE'
export const SET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_ACTION_TYPE = 'SET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_ACTION_TYPE'

export interface IProfileSubscriptionType {
    status: number,
    expirationDate: string,
}

export interface IProfileStatisticsType {
    timePlayedInTicks: number,
    chartsPlayed: number,
    totalTaps: number,
    chartsWritten: number,
    chartsRated: number,
    maxDifficultyPassed: number,
}

export interface IProfileType {
    userName: string,
    registrationDate: Date,
    statistics: IProfileStatisticsType,
    subscription: IProfileSubscriptionType,
}

export interface IExportUserGdprReportType {
    nextRequestTime: Date | null,
}

export interface ICanExportGdprReportType {
    requestTime: Date | null,
}

export interface IRequestUserYearInReviewReportType {
    year: number,
}

export interface ICanRequestYearInReviewReportType {
    canRequest: boolean,
    acceptedYears: number[],
}

export interface IGetProfileAction {
    type: typeof GET_PROFILE_ACTION_TYPE;
    json: {
        profile: IProfileType,
    }
}

export interface IExportUserGdprReportAction {
    type: typeof EXPORT_USER_GDPR_REPORT_ACTION_TYPE,
}

export interface IGetUserCanExportGdprReportAction {
    type: typeof GET_USER_CAN_EXPORT_GDPR_REPORT_ACTION_TYPE,
}

export interface ISetUserCanExportGdprReportAction {
    type: typeof SET_USER_CAN_EXPORT_GDPR_REPORT_ACTION_TYPE,
}

export interface IRequestUserYearInReviewReportAction {
    type: typeof REQUEST_USER_YEAR_IN_REVIEW_REPORT_ACTION_TYPE,
    year: number,
}

export interface IGetUserCanRequestYearInReviewReportAction {
    type: typeof GET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_ACTION_TYPE,
    years: number[],
}

export interface ISetUserCanRequestYearInReviewReportAction {
    type: typeof SET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_ACTION_TYPE,
}

// Creates an action to get the user's profile information.
export const createGetProfileAction = () => {
    return {
        type: GET_PROFILE_ACTION_TYPE,
    }
};

// Creates a new action to export the user's stored data as a report for GDPR (make server call).
export const createExportUserGdprReportAction = () : IExportUserGdprReportAction => {
    return {
        type: EXPORT_USER_GDPR_REPORT_ACTION_TYPE,
    }
}

// Creates a new action to get the user's ability to export a GDPR report (make server call).
export const createGetUserCanExportGdprReportAction = () : IGetUserCanExportGdprReportAction => {
    return {
        type: GET_USER_CAN_EXPORT_GDPR_REPORT_ACTION_TYPE,
    }
}

// Creates a new action to set the user's ability to export a GDPR report (local redux storage).
export const createSetUserCanExportGdprReportAction = () : ISetUserCanExportGdprReportAction => {
    return {
        type: SET_USER_CAN_EXPORT_GDPR_REPORT_ACTION_TYPE,
    }
}

// Creates a new action to request the user's year in review report for the specified year (make server call).
export const createRequestUserYearInReviewReportAction = (year: number) : IRequestUserYearInReviewReportAction => {
    return {
        type: REQUEST_USER_YEAR_IN_REVIEW_REPORT_ACTION_TYPE,
        year: year,
    }
}

// Creates a new action to get the user's ability to reuqest a year in review report (make server call).
export const createGetUserCanRequestYearInReviewReportAction = (years: number[]) : IGetUserCanRequestYearInReviewReportAction => {
    return {
        type: GET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_ACTION_TYPE,
        years: years,
    }
}

// Creates a new action to set the user's ability to request a year in review report (local redux storage).
export const createSetUserCanRequestYearInReviewReportAction = () : ISetUserCanRequestYearInReviewReportAction => {
    return {
        type: SET_USER_CAN_REQUEST_YEAR_IN_REVIEW_REPORT_ACTION_TYPE,
    }
}